import { popupMessage } from '../../messages/business-logic/popup-message';
import {
  closeRecallScanAndGoDialog,
  showRecallScanAndGoDialog,
} from '../components/recall-scan-and-go/recall-scan-and-go-modal';
import { getTransactionsScanAndGoLookup } from 'src/common/helpers/transaction-helper';
import { recallTransaction } from '../../search-transactions/business-logic/recall-transaction';

export const pushScanAndGoModal = () => {
  const onClose = closeRecallScanAndGoDialog;
  const onSearch = getTransactionsScanAndGoLookup;

  const onRecall = (transactionId?: string) => {
    if (transactionId) {
      recallTransaction(transactionId, false)
        .then(onClose)
        .catch(popupMessage);
    }
  };

  const onScan = async (scanData: string): Promise<void> => {
    recallTransaction(scanData, true)
      .then(onClose)
      .catch(popupMessage);
  };

  getTransactionsScanAndGoLookup()
    .then(transactionsList => {
      showRecallScanAndGoDialog({ onClose, onRecall, onSearch, transactionsList }, onScan);
    })
    .catch(popupMessage);
};
